import { render, staticRenderFns } from "./LevelUpsTable.vue?vue&type=template&id=98a87dda"
import script from "./level-ups-table.ts?vue&type=script&lang=ts&external"
export * from "./level-ups-table.ts?vue&type=script&lang=ts&external"
import style0 from "./level-ups-table.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports